import { Injectable } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationsService {
  /**
   *
   * @param translateService
   * @param storageService
   */
  constructor(private storageService: StorageService,
              private translateService: TranslateService) { }

  /**
   *
   */
  public async init(): Promise<void> {
    const translations = await this.storageService.getItem('core.translations');
    if(translations) {
      this.translateService.setTranslation('de', translations);
    }
  }

  /**
   *
   * @private
   */
  public async setTranslations(translations: any[]): Promise<void> {
    await this.storageService.setItem('core.translations', translations);
    this.translateService.setTranslation('de', translations);
  }

}
